import React, {Suspense} from "react";
import MainDesign from "../MainDesign";
import Meta from "../../components/common/Meta";
import {Await, defer, useLoaderData} from "react-router-dom";
import {TransactionPage, TransactionService} from "../../service/TransactionService";
import TransactionsList from "../../components/admin/transaction/TransactionsList";
import ErrorContent from "../../components/common/error/ErrorContent";
import LoadingPage from "../common/LoadingPage";
import Heading from "../../components/common/header/Heading";

type LoaderData = {
    transactions: Promise<TransactionPage>
}

async function loadTransactions(): Promise<TransactionPage> {
    return await TransactionService.getAdminTransactions('all');
}

export async function loader() {
    return defer({
        transactions: loadTransactions()
    });
}

const TransactionsPage: React.FC = () => {
    const {transactions} = useLoaderData() as LoaderData;

    return (
        <MainDesign containerStyles='py-12 container'>
            <Meta title="Lista transakcji" description="Zarządzanie transakcjami w systemie"/>
            <div className="container py-4">
                <Heading title='Lista transakcji' badgeText='transakcje'
                         subtitle='Sprawdź ostatnie transakcje i ich statusy.'/>
                <Suspense fallback={<LoadingPage styles="pt-10"/>
                }>
                    <Await resolve={transactions} errorElement={<ErrorContent/>}>
                        {(loadedTransactions) => (
                            <TransactionsList transactions={loadedTransactions}/>
                        )}
                    </Await>
                </Suspense>
            </div>
        </MainDesign>
    );
};

export default TransactionsPage;
